import showNotify from "@/services/common/showNotify";
import matchService from "@/services/match";
window.matchService = matchService;

const state = {
  connected: false
};

const getters = {
  isConnected: s => s.connected
};

const mutations = {
  SOCKET_CONNECT(state) {
    state.connected = true;
  },
  SOCKET_DISCONNECT(state) {
    state.connected = false;
  }
};

const actions = {
  async socket_notification({ dispatch, rootGetters }, message) {
    const allowedTypes = [
      "match_started",
      "player_promoted",
      "two_winners",
      "matches_performed",
      "match_status_changed"
    ];
    const { type, match_id } = message;
    const user = rootGetters["auth/user"];
    const isReferee = rootGetters["auth/isReferee"];

    if (allowedTypes.includes(type) && match_id) {
      const shouldUpdateMatch = rootGetters.routeParams.match_id === match_id;
      const preventLoadMatch = isReferee && !shouldUpdateMatch;
      // console.log({ match_id, shouldUpdateMatch, preventLoadMatch });

      if (!preventLoadMatch) {
        const match = await matchService.fetchMatch(match_id);
        const playerSide = matchService.getUserSlot(match, user);

        if (type == "match_status_changed" && shouldUpdateMatch) {
          await dispatch("tournaments/updateMatch", match, { root: true });
        }

        let data = { match };

        if (type === "match_started") {
          if (!shouldUpdateMatch) showNotify(data, "match_started");
        } else if (type === "player_promoted") {
          showNotify(data, "player_promoted");
        } else if (type === "two_winners") {
          showNotify(data, "two_winners");
        } else {
          let status = matchService.detectSecondStatus(match, user, isReferee),
            matchStatus = matchService.getStatus(match.status);

          let hasSecondStatus = [
              "score_not_confirmed",
              "should_confirm_score_side"
            ].includes(status),
            isEndedMatchStatus = [
              "score_confirmed",
              "technical_loose"
            ].includes(matchStatus);

          if (playerSide.length && (hasSecondStatus || isEndedMatchStatus)) {
            data.showBtn = !shouldUpdateMatch;
            data.playerSide = playerSide;

            if (!hasSecondStatus && isEndedMatchStatus) {
              status = matchStatus;
            } else {
              data.timeout = 2500;
            }
            showNotify(data, status);
          }
        }
      }
    }

    if (allowedTypes.includes(type)) {
      await dispatch("tournaments/processTemporaryData", null, { root: true });
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
